<template>
    <div class="container">
        <h2 class="text-muted">Détail du tissu</h2>
        <div class="row">
            <div class="col-12 col-sm-6">
                <div class="d-flex justify-content-between">
                    <strong>Type de tissu : </strong> <span class="card-text">{{ tissu.type_tissu?.label }}</span>
                </div>
                <div class="d-flex justify-content-between">
                    <strong>Couleur : </strong> <span class="tissu-color-swatch" :style="colorStyle(tissu.color)"
                        :title="tissu.color || 'Couleur non définie'"></span>
                </div>
                <div class="d-flex justify-content-between">
                    <strong>Qualité : </strong> <span class="card-text">{{ tissu.quality }}</span>
                </div>
                <div class="d-flex justify-content-between">
                    <strong>Quantité : </strong> <span class="card-text">{{ tissu.quantity }}</span>
                </div>
            </div>

            <div v-if="tissu.image_path" class="col-12 mt-3">
                <div class="card model-image-card">
                    <div class="card-body d-flex justify-content-center align-items-center p-2">
                        <img :src="$api.defaults.assetsBaseURL + tissu.image_path" alt="Image du tissu"
                            class="model-image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import colorMixin from '@/mixins/colorMixin';

export default {
    name: 'TissuView',
    mixins: [colorMixin],
    props: {
        id: {
            type: [String, Number],
            require: true
        }
    },
    data() {
        return {
            tissu: {}
        }
    },
    methods: {
        getTissu() {
            this.$api.get(`/tissus/${this.id}`)
                .then(response => {
                    this.tissu = response.data.data;
                }
                )
                .catch(error => {
                    console.log(error);
                })
        }
    },

    created() {
        this.getTissu();
    }
}
</script>

<style scoped>
.model-image-card {
    max-width: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f8f2ff;
}

.model-image-card img,
.model-image {
    max-width: 100%;
    max-height: 60vh;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
    margin: 0 auto;
}

@media (min-width: 768px) {

    .model-image-card img,
    .model-image {
        max-height: 55vh;
    }
}
</style>